import { API, Auth } from 'aws-amplify'
import React, { useEffect } from 'react'
import {
    Image,
    Row,
    Col,
    Container,
} from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import { NavLink } from "react-router-dom";


import icon1 from '../images/icon1.png';
import icon2 from '../images/icon2.png';
import icon3 from '../images/icon3.png';
import icon4 from '../images/icon4.png';
import icon5 from '../images/icon5.png';
import icon6 from '../images/icon6.png';

import Style from './index.css';

// import SupportImage from '../1b.jpg';
// import SupportImage2 from '../2b.jpg';
// import SupportImage3 from '../3b.jpg';
// import SupportImage4 from '../4b.jpg';

// <Image src={SupportImage3} rounded align="left" />


const Files = (props) => {
    
    const checkUser = async(user) => {
        const token = user.signInUserSession.idToken.jwtToken
        const credentials = await Auth.currentUserCredentials();
        const requestInfo = { headers: { Authorization: token } }
        console.log('checkUser')
        API.get("DocumentSearchUser", `/getuserinfo`, requestInfo)
        .then(response => {
            console.log(response)
            // setUserInfo(response)
            localStorage.setItem('query_searches', response.query_searches)
            localStorage.setItem('entity_searches', response.entity_searches)
            localStorage.setItem('keyword_searches', response.keyword_searches)
        })
        .then(error => {
            console.log(error)
        })
    }
    useEffect(() => {checkUser(props.user)}, [])
    
    return (
        <Container>
            <Row>
                <Col className="header">
                    <h1 className="center-align"><em>LawAI</em></h1>
                    <h2>Solutions</h2>
                </Col>
            </Row>
            <Row>
                <Row>
                <Col className='content'>
                    <div className='list'>
                        <Image src={icon1} className="list-icon" />
                        <div className="info">
                            <NavLink to="/ediscovery">eDiscovery</NavLink>
                            <p className="description">Load your own discovery documents and search/extract content</p>
                        </div>
                        {/* <Button variant="link" style={{'fontSize': '20px'}}></Button>{' '} */}
                    </div>
                    <div className='list'>
                        <Image src={icon4} className="list-icon" />
                        <div className="info">
                            <NavLink to="/summarize">Summarize</NavLink>
                            <p className="description">Translate technical text into simple terms</p>
                        </div>
                    </div>
                </Col>
                    {/* <ul style={{'fontSize': '20px'}}>
                        <li>
                        </li>
                        <li>
                        </li>
                        <li>
                        </li>
                        <li>
                        </li>
                    </ul> */}
                </Row>
                <Row>
                <Col className='content'>
                    <div className='list'>
                        <Image src={icon2} className="list-icon" />
                        <div className="info">
                            <NavLink to="/contractreview">Contract Review</NavLink>
                            <p className="description">Load your own contracts and search/extract content</p>
                        </div>
                        {/* <Button variant="link" style={{'fontSize': '20px'}}></Button>{' '} */}
                    </div>
                    <div className='list'>
                        <Image src={icon5} className="list-icon" />
                        <div className="info">
                            <NavLink to="/question-answering">Q&A</NavLink>
                            <p className="description">Answers to questions of world knowledge base</p>
                        </div>
                    </div>
                    
                </Col>
                </Row>
                <Row>
                <Col className='content'>
                    <div className='list'>
                        <Image src={icon3} className="list-icon" />
                        <div className="info">
                            <NavLink to="/caselawsearch">Legal Research</NavLink>
                            <p className="description">Search case law files</p>
                        </div>
                    </div>
                    <div className='list'>
                        <Image src={icon6} className="list-icon" />
                        <div className="info">
                            <NavLink to="/content-generation">Content Generator</NavLink>
                            <p className="description">Auto generate new text and documents using prompts</p>
                        </div>
                    </div>
                </Col>
                </Row>
            </Row>
        {
            // <Row>
            //     <Col>
            //         <br />
            //         <span>Searching your documents is easy</span>
            //     </Col>
            // </Row>
        //     <Row>
        //         <Col>
        //             <p className="search-option">
        //                 <br />
        //                 <span className="title">1. Start a new search</span>
        //                 <span className="description"><br />Either start a new search r access your search history for a previous search</span>
        //             </p>
        //         </Col>
        //           <Col>
        //             <p className="search-option">
        //                 <br />
        //                 <span className="title">5. Provide search parameters</span>
        //                 <span className="description"><br />Select which search option you want to use</span>
        //             </p>
        //         </Col>
        //   </Row>
        //     <Row>
        //         <Col>
        //             <p className="search-option">
        //                 <br />
        //                 <span className="title">2. Create a project folder</span>
        //                 <span className="description"><br />Provide the project name then add new folder. Alternatively, use an existing project folder</span>
        //             </p>
        //         </Col>
        //          <Col>
        //             <p className="search-option">
        //                 <br />
        //                 <span className="title">6. Analyze answers</span>
        //                 <span className="description"><br />Review answers and select the file link to view the answer in the original document page</span>
        //             </p>
        //         </Col>
        //     </Row>
        //     <Row>
        //         <Col>
        //             <p className="search-option">
        //                 <br />
        //                 <span className="title">3. Add files to your project</span>
        //                 <span className="description"><br />Upload as many files as you want into your project folder. Upload loading times depend on file size</span>
        //             </p>
        //         </Col>
        //          <Col>
        //             <p className="search-option">
        //                 <br />
        //                 <span className="title">6. Analyze answers</span>
        //                 <span className="description"><br />Review answers and select the file link to view the answer in the original document page</span>
        //             </p>
        //         </Col>
        //     </Row>
        //     <Row>
        //         <Col>
        //             <p className="search-option">
        //                 <br />
        //                 <span className="title">4. Select a search option</span>
        //                 <span className="description"><br />Select which search option you want to use</span>
        //             </p>
        //         </Col>
        //          <Col>
        //             <p className="search-option">
        //                 <br />
        //                 <span className="title">7. Create summary</span>
        //                 <span className="description"><br />Name your search and save the results for later access</span>
        //             </p>
        //         </Col>
        //     </Row>
            }
            {
            // <Row>
            //     <Col className="text-align-end">
            //     {
            //         // <NavLink to="/savedsearches">
            //         //     <Button variant="outline-primary">Saved Searches</Button>{' '}
            //         // </NavLink>
            //     }
            //         <NavLink to="/projects">
            //             <Button variant="primary">Select Feature</Button>{' '}
            //         </NavLink>
            //     </Col>
            // </Row>
            }
        </Container>
    );
};
export default Files;
